import React, { useState } from 'react';
import { AudioPlayer, AudioPlayerState } from '../AudioPlayer';

export type ToggleSpeakerButtonProps = {
    mute: boolean;
    disabled: boolean;
    onClick: () => void;
}

export type ToggleSpeakerProps = {
    stream: MediaStream | null;
    SpeakerButton: React.ComponentType<ToggleSpeakerButtonProps>;
}

export function ToggleSpeaker(props: ToggleSpeakerProps) {
    const { stream, SpeakerButton } = props;

    const [pause, setPause] = useState(true);
    const [playing, setPlaying] = useState(false);

    return (
        <React.Fragment>
            <SpeakerButton
                mute={!playing}
                disabled={!stream}
                onClick={() => setPause(!pause)}
            />
            <AudioPlayer
                stream={stream}
                paused={pause}
                onStateUpdate={newState => setPlaying(newState === AudioPlayerState.PLAYING)}
            />
        </React.Fragment>
    );
}

export function withToggleSpeaker(SpeakerButton: React.ComponentType<ToggleSpeakerButtonProps>) {
    function _(props: Omit<ToggleSpeakerProps, 'SpeakerButton'>) {
        return <ToggleSpeaker {...props} SpeakerButton={SpeakerButton} />;
    }

    return _;
}
